export const FEATURE_TOGGLES = {
  TEST_TOGGLE: 'test-toggle',
  TOTAL_REVENUE_STRATEGY_TAB: 'total-revenue-strategy-tab',
  UNIFIED_HOTEL_VIEW: 'unified-hotel-view', // Cleanup ticket: CPS-541
  ROLLING_WINDOW_REFERENCE_RATES: 'rolling-window-reference-rates', // Cleanup ticket: COA-3480
  STAY_RESTRICTION_RATE_GROUP: 'stay-restriction-rate-group', // Cleanup ticket: COA-3787
  BI_NET_REVENUE: 'bi-net-revenue', // Cleanup ticket: TOR-1214
  NET_REVENUE_SETTINGS: 'net-revenue-settings',
  USER_ACCESS: 'user-access', // Cleanup ticket: CPS-747
  BI_SNAPSHOTS: 'business-intelligence-snapshots', // Cleanup ticket: PF-2226
  SMART_INSIGHTS_MODULATION_SETTINGS: 'smart-insights-modulation-settings',
  REACT_SETTINGS_SIDE_PANEL: 'react-settings-side-panel',
  REACT_HEADER: 'react-header',
  SMART_INSIGHTS_REACT: 'smart-insights-react',
  PRICING_MANAGER_DEEP_DISCOUNT: 'pricing-manager-deep-discount', // Cleanup ticket: COA-3830
  PRICING_MANAGER_DEEP_DISCOUNT_AUTOPILOT:
    'pricing-manager-deep-discount-autopilot', // Cleanup ticket: COA-3834
  PRICING_MANAGER_RMS_PIVOT_TABLE: 'pricing-manager-rms-pivot-table', // Cleanup ticket: COA-4226
  DI_BRAND_AND_PROPERTY: 'di-brand-and-property', // Cleanup ticket: DI-1605
} as const;
export type FeatureToggle =
  (typeof FEATURE_TOGGLES)[keyof typeof FEATURE_TOGGLES];
